// The minimum supported controller firmware version for bundle download functionality
export const BUNDLE_DOWNLOAD_MINIMUM_FIRMWARE_VERSION = '2.0.0';
